import { NBC_BASE_URL, SE_BASE_URL, SEP_HELP_BASE_URL } from "./constants";

export const links = {
  home: { href: "/", label: "Home" },
  contact: {
    href: `${SE_BASE_URL}/play/demo#form-section`,
    label: "Contact Us",
  },
  terms: { href: `${SE_BASE_URL}/terms-of-use`, label: "Terms of Use" },
  privacy: {
    href: `${NBC_BASE_URL}/privacy?intake=LocalLive`,
    label: "Privacy Policy",
  },
  cookies: {
    href: `${NBC_BASE_URL}/privacy/cookies#accordionheader2`,
    label: "Ad Choices",
  },
  caNotice: {
    href: `${NBC_BASE_URL}/privacy/california-consumer-privacy-act?intake=LocalLive`,
    label: "CA Notice",
  },
  helpCenter: {
    href: `${SEP_HELP_BASE_URL}/?_gl=1*f9v4i4*_ga*MTA3MTU0NzMyNC4xNzI5MDk1ODMx*_ga_P3VED716HZ*czE3NTAxODYyODEkbzU5JGcxJHQxNzUwMTg3MzMyJGo1OCRsMCRoMA..`,
    label: "Help Center",
  },
};

export default links;
